import { render, staticRenderFns } from "./choose-language.vue?vue&type=template&id=f058822a&scoped=true&lang=pug&"
import script from "./choose-language.vue?vue&type=script&lang=ts&"
export * from "./choose-language.vue?vue&type=script&lang=ts&"
import style0 from "./choose-language.vue?vue&type=style&index=0&id=f058822a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f058822a",
  null
  
)

export default component.exports